import React, { useEffect, useState } from "react";
import './Gestores.css';
import PrivateMenuLeft from "../../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../../sections/Header/privateMenuUp";
import PrivateMenuCampanha from "../privateMenuCampanha";
import useAuth from "../../../../../components/hooks/useAuth";
import { useParams } from "react-router-dom";
import { Button } from "@mui/material";
import Loader from "../../../../../components/Loader";

const HEADER_HEIGHT = 56;
const notifyColor = "#51a197";



const LinkedZapCampaign = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();

  const [linkedZaps, setLinkedZaps] = useState([]);
  const [linkedZapsCampaign, setLinkedZapsCampaign] = useState([]);
  const { id: campaignId } = useParams();

  const [loading, setLoading] = useState(false);
  const [loadingOperation, setLoadingOperation] = useState(false);
  useEffect(() => {

    const loadData = async () => {
      setLoading(true);
      loadAssocLinkedZap();
      loadLinkedZap().then(() => {
        setLoading(false);

      });
    }

    loadData();

  }, []);
  const loadLinkedZap = async () => {
    let response = await getApi("/api/v1/linkedZap/list", []);

    setLinkedZaps(response.lista);
  };

  const loadAssocLinkedZap = async () => {
    let response = await getApi("/api/v1/campaign/assoc/linkedzap/list/" + campaignId, []);

    setLinkedZapsCampaign(response.lista);
  };


  const toggleSelecionada = async (id) => {
    if (loadingOperation == true) {
      return;
    }
    setLoadingOperation(true);
    const isAlreadyAssociated = linkedZapsCampaign.some(
      (item) => item.linked_whatsapp_act_id === id
    );

    const operationType = isAlreadyAssociated ? 'remove' : 'add';
    try {
      let response = await postApi("/api/v1/campaign/assoc/linkedzap", {
        'campaign_id': campaignId,
        'linked_whatsapp_act_id': id,
        'operation_type': operationType // Dinâmico aqui
      });


      // 3. Atualiza as listas após o sucesso
      await loadAssocLinkedZap();

      if (response.status == 'fail') {
        window.alert(response.message)
      }

    } catch (error) {
      console.error("Erro ao processar associação:", error);
      // Aqui você pode tratar o erro (ex: toast de aviso)
    } finally {

      setLoadingOperation(false);
    }


  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <PrivateMenuLeft />
      <PrivateMenuUp />
      <div
        style={{
          marginLeft:
            window.innerWidth <= 768
              ? 56 // Sempre 56px no mobile, independente do sidebarOpen
              : sidebarOpen
                ? 220
                : 70,
          paddingTop: HEADER_HEIGHT,
          width:
            window.innerWidth <= 768
              ? "calc(100vw - 56px)" // Sempre 56px no mobile
              : sidebarOpen
                ? "calc(100% - 220px)"
                : "calc(100% - 70px)",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        }}
      >
        {/* Sidebar Bootstrap 5 */}

        <PrivateMenuCampanha />

        {/* Conteúdo da página de campanha */}
        <div
          style={{
            marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
            paddingTop: HEADER_HEIGHT,
            width: window.innerWidth > 768
              ? sidebarOpen
                ? "calc(100% - 220px)"
                : "calc(100% - 70px)"
              : "100vw",
            transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
            minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
            background: "#f7f7f7",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Título */}
          <h2 style={{
            fontWeight: "bold",
            color: "#005c53",
            fontSize: 28,
            textAlign: "center"
          }}>
            Contas Associadas
          </h2>
          {/* Header da página */}

          {loading && <Loader />}
          {/* Boxes de contas */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 32,
              justifyContent: "center",
              width: "100%",
              maxWidth: 1200,
            }}
          >
            {linkedZaps.map((linkedzap) => {
              // Verificação dinâmica: checa se o ID do Zap atual existe na lista da campanha
              const estaNaCampanha = linkedZapsCampaign.some(
                (item) => item.linked_whatsapp_act_id === linkedzap.id
              );

              return (
                <div
                  key={linkedzap.id} // Corrigido de linkedZaps.id para linkedzap.id
                  onClick={() => toggleSelecionada(linkedzap.id)}

                  style={{
                    background: estaNaCampanha ? notifyColor : "#fff",
                    border: estaNaCampanha ? `3px solid ${notifyColor}` : "2px solid #e0e0e0",
                    borderRadius: 20,
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                    width: 380,
                    minHeight: 180,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    position: "relative",
                    padding: "24px 18px",
                  }}
                >
                  {/* Círculo com foto */}
                  <div
                    style={{
                      width: 64,
                      height: 64,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: `3px solid ${estaNaCampanha ? "#fff" : notifyColor}`,
                      marginBottom: 16,
                      background: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative"
                    }}
                  >
                    <img
                      src={linkedzap.profilePictureUrl}
                      alt={linkedzap.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />

                    {/* Indicador de Status Online (Pulsação Verde) */}
                    <span
                      style={{
                        position: "absolute",
                        bottom: "-8px",
                        right: "-8px",
                        width: 48,
                        height: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          background: "rgba(123, 138, 108, 0.8)",
                          animation: linkedzap.connected ? 'pulseVerde 1.2s infinite' : 'pulseVermelho 1.2s infinite',
                        }}

                      ></span>
                      <span
                        style={{
                          position: "relative",
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          background: linkedzap.connected ? "#28c76f" : "#ff0000",
                          border: linkedzap.connected ? "1px solid #28c76f" : "1px solid #ff0000",
                          zIndex: 1,
                        }}
                      ></span>
                    </span>
                  </div>

                  {/* Nome da conta */}
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: estaNaCampanha ? "#fff" : "#005c53",
                      marginBottom: 6,
                      textAlign: "center",
                    }}
                  >
                    {linkedzap.name}
                  </div>

                  {/* Número da conta */}
                  <div
                    style={{
                      fontSize: 16,
                      color: estaNaCampanha ? "#fff" : "#333",
                      marginBottom: 16,
                      textAlign: "center",
                    }}
                  >
                    {linkedzap.whatsapp_id}
                  </div>

                  {/* Botão de Ação */}
                  <div
                    style={{
                      width: "80%",
                      margin: "0 auto",
                      marginTop: "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        width: "100%",
                        padding: "10px 0",
                        borderRadius: 10,
                        border: "none",
                        background: estaNaCampanha ? "#fff" : notifyColor,
                        color: estaNaCampanha ? notifyColor : "#fff",
                        fontWeight: "bold",
                        fontSize: 16,
                        cursor: "pointer",
                        boxShadow: estaNaCampanha
                          ? "0 2px 8px rgba(0,92,83,0.10)"
                          : "0 1px 4px rgba(0,0,0,0.07)",
                        transition: "all 0.2s",
                        outline: estaNaCampanha ? `2px solid #fff` : "none",
                      }}
                      disabled={loading}
                      onClick={(e) => {
                        e.stopPropagation(); // Evita disparar o clique do card pai
                        toggleSelecionada(linkedzap.id);
                      }}
                    >
                      {estaNaCampanha ? "Selecionada" : "Selecionar"}
                    </button>

                    {loadingOperation && <Loader />}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </div >
  );
};

export default LinkedZapCampaign;


const style = document.createElement('style');
style.innerHTML = `
@keyframes pulseVerde {
  0% { box-shadow: 0 0 0 0 #28c76f; }
  70% { box-shadow: 0 0 0 10px #ff980000; }
  100% { box-shadow: 0 0 0 0 #ff980000; }
}
  
@keyframes pulseVermelho {
  0% { box-shadow: 0 0 0 0 #b96a5c; }
  70% { box-shadow: 0 0 0 10px #ff980000; }
  100% { box-shadow: 0 0 0 0 #ff980000; }
}`;

document.head.appendChild(style);